import type { CheckoutShippingStepData } from "@jti/store/slices/standardCheckoutFormSlice";
import { useFormContext } from "@jti/ui";

export const useShippingFormContext = () => useFormContext<CheckoutShippingStepData>();
